import React, { useEffect } from 'react';
import './DevAdBanner.css';

function DevAdBanner({ className = '', style = {} }) {
	// Only render in development builds
	if (!(import.meta && import.meta.env && import.meta.env.DEV)) {
		return null;
	}

	// Inject AdSense script only in development
	useEffect(() => {
		const scriptSrc = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5296044109961471';
		const alreadyPresent = Array.from(document.scripts).some(s => s.src === scriptSrc);
		if (!alreadyPresent) {
			const script = document.createElement('script');
			script.async = true;
			script.src = scriptSrc;
			script.crossOrigin = 'anonymous';
			document.head.appendChild(script);
		}
	}, []);

	return (
		<div
			className={`dev-ad-banner ${className}`.trim()}
			style={style}
			role="complementary"
			aria-label="Development ad placeholder"
		>
			<div className="dev-ad-inner">
				<span className="dev-ad-label">Ad</span>
				<span className="dev-ad-text">Development placeholder — banner slot</span>
			</div>
		</div>
	);
}

export default DevAdBanner;


